export default [
    {
        path: '/forms', component: () => import('./components/Page'), name: 'forms.page', children: [
            {path: '', component: () => import('./components/List'), name: 'forms.list'},
            {path: ':id', component: () => import('./components/Form'), name: 'forms.show'},
        ]
    }
]
